import { useSelector, shallowEqual } from "react-redux";
import SelectedFlightRecap from "app/pages/Booking/Quotation/Flight/SelectedFlightRecap/SelectedFlightRecap";
import PropTypes from "prop-types";
import { luggageShape, quotationFlightShape } from "app/utils/propTypes";
import { getMaxLuggageCount } from "app/pages/Booking/bookingSelectors";
import isEmpty from "lodash/isEmpty";
import { getFlightOptionsStatus } from "app/pages/Booking/Quotation/quotationSelectors";
import { FLIGHT_OPTIONS_STATUS } from "app/constants";
import { getFlightOptionsOfSelectedFlight } from "app/pages/Booking/bookingSelectors";

const mapStateToProps = state => {
	const includedFlight = state.booking.flight;
	const flightOptionsStatus = getFlightOptionsStatus(state);

	return {
		isLoading:
			!includedFlight ||
			isEmpty(includedFlight) ||
			flightOptionsStatus === FLIGHT_OPTIONS_STATUS.LOADING,
		flight: includedFlight,
		departureCity: state.booking.departureCity?.label,
		destination: state.booking.destinationResort?.label,
		luggageMaxCount: getMaxLuggageCount(state),
		flightLuggageOption: getFlightOptionsOfSelectedFlight(state)?.flightBagageOption,
	};
};

const SelectedFlightRecapContainer = props => {
	const stateProps = useSelector(mapStateToProps, shallowEqual);
	return <SelectedFlightRecap {...props} {...stateProps} />;
};
SelectedFlightRecapContainer.propTypes = {
	includedFlight: quotationFlightShape,
	luggageMaxCount: PropTypes.number,
	onClick: PropTypes.func,
	flightLuggageOption: luggageShape,
};
export default SelectedFlightRecapContainer;
